import { breazeConfig } from '../../lib/breaze/config';

const loadConfig = () => {
  return Promise.resolve(breazeConfig);
};

export default loadConfig;
